<template>
  <v-main class="equity-page">
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">
        <span>权益</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="ml-4" color="primary" small @click="onCreateEquity">创建权益</v-btn>
      <v-btn class="ml-4" color="primary" small @click="onCreateGroup">添加分组</v-btn>
    </v-app-bar>
    <v-container fluid class="content">
      <div class="equity-group" v-for="(group, index) in groupFormList" :key="index">
        <div class="group-header">
          <template v-if="group.is_virtual">
            <div class="group-label">#</div>
            <div class="group-name">{{ group.name }}</div>
          </template>
          <v-text-field v-else v-model="group.name" placeholder="权益分组名称" hint="权益分组名称，例如：会员组">
            <template #prepend>
              <div class="group-label">#</div>
            </template>
          </v-text-field>
          <template v-if="!group.is_virtual">
            <v-btn class="ml-4" color="primary" outlined small @click="onSaveGroup(group, index)">保存</v-btn>
            <v-tooltip bottom :disabled="canDeleteGroup(group)">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" class="btn-delete-group" :class="{ 'disabled': !canDeleteGroup(group) }"
                  outlined small @click="onDeleteGroup(group, index)">删除</v-btn>
              </template>
              <span>只能删除空的分组</span>
            </v-tooltip>
          </template>
          <template v-else>
            <div class="group-label-default">默认分组</div>
          </template>
        </div>
        <div class="group-content">
          <v-list dense class="group-list">
            <v-list-item v-for="item in listOfGroup(group)" :key="item.id" @click="onClickItem(item.id)">
              <v-row class="equity-row" align="center" justify="space-between">
                <v-col class="col-name" cols="4">{{ item.name }}</v-col>
                <v-col cols="8" class="equity-info">
                  <div class="equity-patttern">{{ patternNameOf(item.pattern) }}</div>
                  <div class="equity-profit-ratio" v-if="isPromoter(item.pattern)">{{
                    formatProfitRatio(item.profit_ratio) }}
                  </div>
                  <div class="equity-index" v-else>
                    <span class="equity-index-label">
                      <v-icon small>{{ mdiChevronDoubleDown }}</v-icon>
                    </span>
                    <span class="equity-index-value">{{ item.index }}</span>
                  </div>
                  <div class="equity-initial-amount">试用: {{ formatAmount(item.initial_amount, item.pattern) }}</div>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </v-container>
  </v-main>
</template>
  
<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { homeStore } from '@/store/home'
import { equityStore } from '@/store/equity'
import { EquityPattern } from '@/plugins/payment'
import { formatAmount } from '@/plugins/duration'
import { formatProfitRatio } from '@/plugins/promoter'
import { mdiChevronDoubleDown } from '@mdi/js'

export default {
  name: 'EquityListPage',
  components: { AppbarBackIcon },

  data() {
    return {
      mdiChevronDoubleDown,
      groupFormList: [],
    }
  },
  computed: {
    hasEquityGroup() {
      return equityStore.groupList.length > 0
    },
  },
  async mounted() {
    await homeStore.doLoad()
    await equityStore.doLoad()
    equityStore.groupList.forEach(group => {
      this.groupFormList.push(this.formOfGroup(group))
    })
  },
  methods: {
    formOfGroup(group) {
      return {
        id: group.id,
        name: group.name,
        is_virtual: group.is_virtual,
      }
    },
    listOfGroup(group) {
      return equityStore.listOfGroup(group.id)
    },
    canDeleteGroup(group) {
      if (group.is_virtual) { return false }
      return this.listOfGroup(group).length <= 0
    },
    onCreateGroup() {
      this.groupFormList.unshift({
        id: null,
        name: null,
        is_virtual: false,
      })
    },
    async onSaveGroup(group, index) {
      if (!group.name) {
        this.$toasted.error('请输入分组名称')
        return
      }
      let result = await equityStore.doSaveGroup(group)
      this.groupFormList.splice(index, 1, this.formOfGroup(result))
      this.$toasted.success('保存成功')
    },
    async onCreateEquity() {
      this.$router.push({
        path: '/dash/equity-detail',
      })
    },
    async onDeleteGroup(group, index) {
      if (!this.canDeleteGroup(group)) {
        this.$toasted.error('只能删除空的分组')
        return
      }
      if (group.id) {
        await equityStore.doDeleteGroup({ id: group.id })
        this.$toasted.success('删除成功')
      }
      this.groupFormList.splice(index, 1)
    },
    patternNameOf(value) {
      return {
        [EquityPattern.SUBSCRIPTION]: '订阅/永久',
        [EquityPattern.CONSUMABLE]: '积分/消耗品',
        [EquityPattern.PROMOTER]: '推广员',
      }[value]
    },
    formatAmount(amount, pattern) {
      return formatAmount({ amount, pattern })
    },
    formatProfitRatio,
    isPromoter(pattern) {
      return pattern === EquityPattern.PROMOTER
    },
    onClickItem(id) {
      this.$router.push({
        path: '/dash/equity-detail',
        query: { id },
      })
    },
  },
}
</script>
  
<style lang="less" scoped>
@import '~@/styles/common';

.content {
  min-height: 16px;
}

.equity-group {
  border: solid 1px @antLineGrey;
  border-radius: 8px;
  margin-top: 16px;
  padding: 0 16px 16px 16px;

  .btn-delete-group {
    color: @antTextSemi;
    margin-left: 16px;

    &.disabled {
      color: @antTextLight;
    }
  }

  .group-label-default {
    position: relative;
    bottom: 2px;
    color: @antTextGrey;
    margin-left: 16px;
    cursor: default;
  }
}

.group-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .group-label {
    position: relative;
    bottom: 2px;
    font-size: 18px;
    line-height: 32px;
    font-weight: bold;
    word-break: keep-all;
  }

  .group-name {
    flex: 1;
    text-align: left;
    line-height: 32px;
    padding: 10px 16px 14px 9px;
  }
}

.group-content {
  .group-list {
    padding: 0;
  }
}

.equity-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.equity-index {
  color: @antTextGrey;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;

  .equity-index-label {
    margin-right: 2px;
    position: relative;
    top: -1px;
  }

  .equity-index-value {
    display: inline-block;
    min-width: 24px;
    text-align: center;
  }
}

.equity-row {
  width: 100%;
  margin-left: -16px;
  margin-right: -16px;
}

.col-name {
  padding-right: 0;
}
</style>
  